export function getIosVersion(): number {
  const isIOS =
    (/iPad|iPhone|iPod/.test(navigator.platform) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) &&
    !window.MSStream;

  if (isIOS) {
    const v = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
    // only return the main version
    // we return -1 when we can't get the version because it indicates this might be iPadOS
    // tslint:disable-next-line: ban
    return v ? parseInt(v[1], 10) : -1;
  } else {
    return -1;
  }
}
